import { HttpContextToken } from "@angular/common/http";

export const skipAuth = new HttpContextToken<boolean>(() => false);
export const skipLoading = new HttpContextToken<boolean>(() => false);
export const useSessionToken = new HttpContextToken<boolean>(() => false);